// src/components/CalendarView/CalendarHeader.tsx
import React from 'react';
import type { CalendarViewMode } from './types';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function getWeekNumber(d: Date): number
{
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function formatTitle(mode: CalendarViewMode, date: Date): string
{
  if (mode === 'month')
  {
    return `${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
  }
  if (mode === 'week')
  {
    return `Week ${getWeekNumber(date)} of ${date.getFullYear()}`;
  }
  // day
  const dayName = DAY_NAMES[date.getDay()];
  const dayNum = date.getDate();
  const monthName = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${dayName} ${dayNum} ${monthName}, ${year}`;
}

interface CalendarHeaderProps {
  calViewMode: CalendarViewMode;
  currentDate: Date;
  onViewModeChange: (mode: CalendarViewMode) => void;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  calViewMode,
  currentDate,
  onViewModeChange,
  onPrev,
  onNext,
  onToday,
}) =>
{
  return (
    <div className="cal-header">
      <div className="cal-header-left">
        <button className="cal-nav-btn" onClick={onPrev} title="Previous">
          {' '}
          <i className="fa fa-caret-left" />
        </button>
        <span className="cal-header-title">{formatTitle(calViewMode, currentDate)}</span>
        <button className="cal-nav-btn" onClick={onNext} title="Next">
          {' '}
          <i className="fa fa-caret-right" />
        </button>
      </div>
      <div className="cal-header-right">
        {(['month', 'week', 'day'] as CalendarViewMode[]).map(mode => (
          <button
            key={mode}
            className={`cal-view-btn${calViewMode === mode ? ' active' : ''}`}
            onClick={() => onViewModeChange(mode)}
          >
            {mode.charAt(0).toUpperCase() + mode.slice(1)}
          </button>
        ))}
        <button className="cal-today-btn " onClick={onToday}>
          Today
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;
